import { styled } from '@mui/system';

const baseStyles = theme => ({
  position: 'sticky',
  display: 'grid',
  alignItems: 'center',
  gridGap: theme.spacing(1),
  padding: theme.spacing(2, 4, 2, 4),
  width: '100%',
  backgroundColor: '#EEE',
  zIndex: 1100
});

export const DefaultPageBar = styled('div')(({ theme }) => ({
  ...baseStyles(theme),
  gridTemplateColumns: 'auto 375px',
  gridTemplateAreas: '"filter dateRange"',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 2, 1),
    gridTemplateRows: 'auto auto'
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    gridTemplateAreas: '"dateRange sortControl" "filter filter"',
    gridTemplateColumns: 'auto',
    padding: theme.spacing(3, 1, 2, 1)
  }
}));

export const ShipmentPageBar = styled('div')(({ theme }) => ({
  ...baseStyles(theme),
  gridTemplateColumns: 'auto 160px',
  gridTemplateAreas: '"filter addBtn"',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 2, 1),
    gridTemplateColumns: 'auto 160px',
    gridTemplateRows: 'auto'
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3, 1, 2, 1),
    gridTemplateAreas: '"addBtn addBtn" "filter filter"'
  }
}));

export const ProjectPageBar = styled('div')(({ theme }) => ({
  ...baseStyles(theme),
  gridTemplateColumns: 'auto 160px',
  gridTemplateAreas: '"filter addBtn"',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 2, 1),
    gridTemplateColumns: 'auto 160px',
    gridTemplateRows: 'auto'
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3, 1, 2, 1),
    gridTemplateAreas: '"addBtn addBtn" "filter filter"'
  }
}));

export const LogPageBar = styled('div')(({ theme }) => ({
  position: 'sticky',
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 4, 2, 4),
  width: '100%',
  backgroundColor: '#EEE',
  zIndex: 1100,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2, 1, 2, 1)
  },
  [theme.breakpoints.down('sm')]: {
    alignItems: 'center',
    padding: theme.spacing(3, 1, 2, 1)
  }
}));
